/** JLR Enroll Form 2026 — aligned with JotForm form 261165188585164 */

export const JLR_FORM_ID = "261165188585164";

/** POST name for DEALER CODE short text (qid 104); must match JotForm. */
export const JLR_DEALER_CODE_NAME = "q104_dealerCode";

/** Checkbox `value` and agreement text for `q25_input28[]` (must match JotForm). */
export const JLR_TALENT_AGREEMENT_VALUE =
  'Dealer agrees to pay the fees for the Services in the amounts set forth in the online registration process or, if an order form was used, on the order form. The fees for the Services shall be billed to and Dealer agrees to pay the media for the Services through Constellation directly. Cancellations that occur on or before the 10th day of each calendar month will be billed for the remainder of that month.';

/**
 * @typedef {{ id: string, label: string, checkboxQid: string, checkboxName: string, checkboxValue: string, budgetQid: string, budgetName: string }} JlrChannelField
 * @type {JlrChannelField[]}
 */
export const JLR_CHANNELS = [
  {
    id: "seo",
    label: "SEO + AEO",
    checkboxQid: "76",
    checkboxName: "q76_seo",
    checkboxValue: "SEO + AEO",
    budgetQid: "77",
    budgetName: "q77_monthlyBudget",
  },
  {
    id: "openaiAds",
    label: "OPENAI ADS",
    checkboxQid: "78",
    checkboxName: "q78_openaiAds",
    checkboxValue: "OPENAI ADS",
    budgetQid: "79",
    budgetName: "q79_monthlyBudget79",
  },
  {
    id: "display",
    label: "DISPLAY",
    checkboxQid: "80",
    checkboxName: "q80_display",
    checkboxValue: "DISPLAY",
    budgetQid: "81",
    budgetName: "q81_monthlyBudget81",
  },
  {
    id: "ctv",
    label: "CTV / OTT",
    checkboxQid: "82",
    checkboxName: "q82_ctv",
    checkboxValue: "CTV / OTT",
    budgetQid: "83",
    budgetName: "q83_monthlyBudget83",
  },
  {
    id: "audio",
    label: "AUDIO",
    checkboxQid: "84",
    checkboxName: "q84_audio",
    checkboxValue: "AUDIO",
    budgetQid: "85",
    budgetName: "q85_monthlyBudget85",
  },
  {
    id: "nbcSpot",
    label: "NBC SPOT ON AUTO",
    checkboxQid: "86",
    checkboxName: "q86_nbcSpot",
    checkboxValue: "NBC SPOT ON AUTO",
    budgetQid: "87",
    budgetName: "q87_Monthly",
  },
  {
    id: "search",
    label: "SEARCH",
    checkboxQid: "88",
    checkboxName: "q88_search",
    checkboxValue: "SEARCH",
    budgetQid: "89",
    budgetName: "q89_monthlyBudget89",
  },
  {
    id: "pmax",
    label: "PMAX",
    checkboxQid: "90",
    checkboxName: "q90_pmax",
    checkboxValue: "PMAX",
    budgetQid: "91",
    budgetName: "q91_monthlyBudget91",
  },
  {
    id: "youtube",
    label: "YOUTUBE",
    checkboxQid: "92",
    checkboxName: "q92_youtube",
    checkboxValue: "YOUTUBE",
    budgetQid: "93",
    budgetName: "q93_Monthly93",
  },
  {
    id: "vlas",
    label: "VLAS",
    checkboxQid: "94",
    checkboxName: "q94_vlas",
    checkboxValue: "VLAS",
    budgetQid: "95",
    budgetName: "q95_monthlyBudget95",
  },
  {
    id: "metafb",
    label: "META (FB / INSTAGRAM)",
    checkboxQid: "102",
    checkboxName: "q102_metafb",
    checkboxValue: "META (FB / INSTAGRAM)",
    budgetQid: "103",
    budgetName: "q103_monthlyBudget103",
  },
  {
    id: "contentAutomation",
    label: "CONTENT AUTOMATION",
    checkboxQid: "100",
    checkboxName: "q100_contentAutomation",
    checkboxValue: "CONTENT AUTOMATION",
    budgetQid: "101",
    budgetName: "q101_Monthly101",
  },
  {
    id: "landingPage",
    label: "LANDING PAGE",
    checkboxQid: "96",
    checkboxName: "q96_landingPage",
    checkboxValue: "LANDING PAGE",
    budgetQid: "97",
    budgetName: "q97_Monthly97",
  },
];

export function createEmptyJlrChannelState() {
  return Object.fromEntries(
    JLR_CHANNELS.map((c) => [c.id, { checked: false, budget: "" }])
  );
}
